import _ from "lodash";
import * as ActionType from "../actionType";
import { getProductsApi } from "../../services/product/products";
import { dispatchWishlist } from "../quotes";

const getProductsAction = () => {
  return async (dispatch, getState) => {
    dispatchProducts(dispatch, getState);
  };
};

const dispatchProducts = (dispatch, getState) => {
  dispatch({ type: ActionType.FETCHING_PRODUCTS });
  getProductsApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PRODUCTS,
      data
    });
    dispatchWishlist(dispatch, getState);
  });
};

const dispatchRecentlyProduct = dispatch => {
  let recentlyProduct = window.localStorage.getItem("recentlyProduct");
  if (!_.isEmpty(recentlyProduct)) {
    recentlyProduct = JSON.parse(recentlyProduct);
    dispatch({
      type: ActionType.RECEIVE_PRODUCTS_RECENTLY_VIEW,
      data: recentlyProduct
    });
  }
};

const addRecentlyProductAction = id => {
  return async dispatch => {
    dispatch({
      type: ActionType.ADD_PRODUCTS_RECENTLY_VIEW,
      id: _.toInteger(id)
    });
  };
};

export { getProductsAction, dispatchProducts, dispatchRecentlyProduct, addRecentlyProductAction };



// WEBPACK FOOTER //
// ./src/actions/product/products.js